import { DisplayNames, Maybe } from '@typings/graphql';

export const getDisplayNameById = (
  displayNames: Array<DisplayNames>,
  displayCode?: Maybe<string>
) => displayNames?.find(({ id }) => displayCode === id)?.name || '';
